<template>
    <tbody>
        <tr>
            <td>
                {{ group.id }}
            </td>
            <td>
                {{ group.name }}
            </td>
            <td class="text-light">
                <groups-stats-component
                    :ips="ips"
                    :groupId="group.id"
                />
            </td>
            <td>
                <div class="text-right">
                    <button
                        v-if="!ipsByGroupId.length"
                        class="btn btn-sm btn-danger"
                        type="button"
                        @click="deleteGroupModal()"
                    >
                        <i class="fa fa-trash"></i>
                        <span class="sr-only">Delete</span>
                    </button>
                    <button
                        class="btn btn-sm btn-warning"
                        type="button"
                        @click="addIpModal()"
                    >
                        <i class="fa fa-plus"></i>
                        <span class="sr-only">Add IP</span>
                    </button>
                    <a
                        :href="getRoute('edit')"
                        class="btn btn-sm btn-primary"
                    >
                        <i class="fa fa-edit"></i>
                        <span class="sr-only">Edit</span>
                    </a>
                    <a
                        :href="getRoute('show')"
                        class="btn btn-sm btn-info"
                    >
                        <i class="fa fa-eye"></i>
                        <span class="sr-only">Show</span>
                    </a>
                    <span
                        class="btn btn-sm btn-info"
                        @click="toggleGroup()"
                    >
                        <i :class="[collapse ? 'fa-caret-up' : 'fa-caret-down']" class="fa"></i>
                        <span class="sr-only">Show</span>
                    </span>
                </div>
            </td>
        </tr>
        <tr>
            <td colspan="4" class="no-padding">
                <vue-slide-up-down
                    :active="collapse"
                    :duration="collapseDuration"
                >
                    <div class="box box-primary">
                        <div class="box-body table-responsive no-padding">
                            <ips-table-component
                                :ips="ipsByGroupId"
                                :ipGroups="ipGroups"
                                :type="0"
                            />
                        </div>
                    </div>
                </vue-slide-up-down>
            </td>
        </tr>
    </tbody>
</template>

<script>
import GroupsStatsComponent from "./GroupsStatsComponent";
import IpsTableComponent from "../ip/IpsTableComponent";
import EventBus from "../../../../event-bus";
import ipTypes from "../../data/ipTypes";
import routes from "../../data/routes";

export default {
    props: {
        ips: Array,
        ipGroups: Array,
        group: Object,
        collapse: Boolean
    },
    data() {
        return {
            collapseDuration: 700,
            modal: {},
            showModal: false,
            ipTypes,
            routes
        }
    },
    methods: {
        deleteGroupModal() {
            EventBus.$emit('showModalForm', {
                method: 'delete',
                emitUpdateMethod: 'deleteGroupModalUpdate',
                route: this.routes.group.delete.replace(':id', this.group.id),
                headerText: `Delete Group #${ this.group.name }`,
                bodyHeaderText: `Confirm delete ${ this.group.name }, please.`,
            });
        },
        addIpModal() {
            EventBus.$emit('showModalForm', {
                method: 'post',
                emitUpdateMethod: 'addIpModalUpdate',
                route: this.routes.ip.create,
                headerText: `Create IP in "${this.group.name}"`,
                size: 'sm',
                buttonApproveText: 'Create',
                formData: [
                    {
                        key: 'group_id',
                        value: this.group.id,
                        type: 'hidden'
                    },
                    {
                        key: 'type',
                        value: 0,
                        type: 'select',
                        title: 'Type',
                        options: this.ipTypes
                    },
                    {
                        key: 'ip',
                        value: '',
                        type: 'text',
                        title: 'IP'
                    }
                ]
            });
        },
        getRoute(type) {
            return this.routes.group[type].replace(':id', this.group.id);
        },
        toggleGroup() {
            this.$emit('toggleGroup', this.group.id);
        }
    },
    computed: {
        ipsByGroupId: function () {
            return this.ips.filter((item) => item.group_id === this.group.id);
        }
    },
    components: {
        GroupsStatsComponent,
        IpsTableComponent
    }
}
</script>
<style scoped>
.table-responsive {
    overflow: visible;
}
.box-primary {
    margin: 0;
}
</style>
